module.exports = __webpack_public_path__ + "img/img_ serve3.2e728c1d.png";